// extracted by mini-css-extract-plugin
export default {"logo":"style-module__logo___POxtd","reauth_container":"style-module__reauth_container___bsrUZ"};